import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../password-grant/auth.service';

export const AccessGuard: CanActivateFn | CanActivateChildFn = (route): boolean => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const roles = route.data?.['role'] ?? route.data?.['roles'];
    const permissions = route.data?.['permission'] ?? route.data?.['permissions'];

    if (auth.hasAccess({ roles, permissions })) {
        return true;
    }

    void router.navigate(['/dashboard']);
    return false;
};
